import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestSuccessConditionsEnum as SuccessEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  SUCCESS_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";

import { useStepStyles } from "./stepStyles";

type SuccessStepProps = {
  successConditions: SuccessEnum[];
  onSuccessConditionsChange: (next: SuccessEnum[]) => void;
};

const SuccessStep: React.FC<SuccessStepProps> = ({ successConditions, onSuccessConditionsChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>あなたにとっての成功</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[4]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={SUCCESS_OPTIONS}
          selected={successConditions}
          onChange={onSuccessConditionsChange}
        />
      </Box>
    </>
  );
};

export default SuccessStep;
